import { Outlet } from "react-router-dom";

const DefaultOutlet = () => {
    return (
        <div>
            <Outlet />
        </div>
    );
}

export default DefaultOutlet